import { render, staticRenderFns } from "./contactOrdersVariationWidget.vue?vue&type=template&id=3fed8a54&"
import script from "./contactOrdersVariationWidget.vue?vue&type=script&lang=js&"
export * from "./contactOrdersVariationWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports